import { render } from "./minus-filled.vue?vue&type=template&id=c6d206d2"
import script from "./minus-filled.vue?vue&type=script&lang=js"
export * from "./minus-filled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__